import { useIsMobile } from "../../utils/functions/useIsMobile";
import { IconProps } from "./IconProps";

export const GameArrowUpIcon = ({ className }: IconProps) => {
  const isMobile = useIsMobile();

  return isMobile ? (
    <svg
      className={className}
      width="16"
      height="10"
      viewBox="0 0 16 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.92342 0.468446C7.518 -0.156148 8.482 -0.156149 9.07658 0.468445L15.551 7.2697C16.5101 8.27725 15.8309 10 14.4744 10L1.52557 10C0.169151 10 -0.510145 8.27725 0.448987 7.2697L6.92342 0.468446Z"
        fill="white"
      />
    </svg>
  ) : (
    <svg
      className={className}
      width="26"
      height="16"
      viewBox="0 0 26 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6046 0.61777C12.3753 -0.205926 13.6247 -0.205924 14.3954 0.617773L25.4181 12.3994C26.6612 13.7281 25.7808 16 24.0227 16L1.9773 16C0.219239 16 -0.661203 13.7281 0.581937 12.3994L11.6046 0.61777Z"
        fill="white"
      />
    </svg>
  );
};
